import { useTranslation } from "react-i18next";

export default function RouteFallback() {
  const { t } = useTranslation();

  return (
    <div className="grid min-h-screen place-content-center justify-items-start p-8 font-mono text-xs tracking-label text-primary">
      {t("common.loading")}
    </div>
  );
}
